export default __webpack_public_path__ + "static/media/orange.60ca9a8a.jpg";